import AddPersonDialog from './AddPersonDialog.container';
export default AddPersonDialog;
